import { Component } from '@angular/core';
import { WalletTransferItem, WalletTransferItemWithOwner } from '../../../api/models';
import { FormGroup, FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BookingService } from '../../../api/services';

@Component({
  selector: 'app-wallet-transfer-set-status',
  templateUrl: './wallet-transfer-set-status.component.html',
  styleUrl: './wallet-transfer-set-status.component.scss',
})
export class WalletTransferSetStatusComponent {
  transfer?: WalletTransferItemWithOwner;
  statuses = new FormGroup({
    status: new FormControl<number | null>(null),
  });

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private boService: BookingService,
    private messageService: MessageService
  ) {
    this.transfer = config.data.transfer;
    this.statuses.get('status')!.setValue(this.transfer!.status.id);
  }

  save() {
    if (this.statuses.dirty) {
      this.boService
        .bookingControllerWalletTransferSetStatus({
          id: this.transfer!.id,
          body: { status_id: this.statuses.get('status')!.value! },
        })
        .subscribe({
          next: () => {
            this.ref.close({ done: true });
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Imposta stato',
              detail: "L'operazione non può essere completata",
            });
          },
        });
    }
  }
}
